/*    
<summary>
  This functional component is used for proper authentication of user using the Login Credentials (Username & Password)
  Developer:Aashish Singh, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date: 26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import React, { useEffect } from "react";
import { toast } from "react-toastify";
import "../../auth/login.css";
import { formatMessage } from "../../../translations/format-message";
import { observer } from "mobx-react";
import { useStore } from "../../../contexts/store-provider";
import { useCookies } from "react-cookie";
import ILogin, { ICustomerLogin } from "../../../models/forms/ILogin";
import RoutesConstants from "../../../shared-components/routes/routes-constants";

import Footer from "../../../shared-components/footer/footer";
import { errorMessage } from "../../../constants/error-constants";
import { useHistory, useLocation } from "react-router-dom";
import CustomerLoginForm from "./forms/customer-login-form";
 
const CustomerLogin = (props: any) => {
  const history = useHistory();
  const location = useLocation();
  const { authStore, preferencesStore } = useStore();

  const { error, inProgress, getUserType }: any = authStore;
  const { getVersion } = preferencesStore;
  const { isAuthenticated, getToken, Customerlogin } = authStore;
  const [cookies, setCookie, removeCookie] = useCookies(["customerEmail"]);
  const emailFromCookies = cookies.customerEmail;
  const initialValues: ICustomerLogin = {
    email: emailFromCookies !== undefined ? emailFromCookies : "",
    password: "",
    rememberMe: emailFromCookies !== undefined ? true : false,
  };

  /**
   * This function handles login functionlity for user
   */
  const handleLogin = (values: ICustomerLogin) => {
    if (values.rememberMe == true) {
      setCookie("customerEmail", values.email);
    } else {
      if (cookies.customerEmail != "") {
        removeCookie("customerEmail");
      }
    }
    Customerlogin(values);
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "isAuthenticated" of the useEffect changed.
   */
  useEffect(() => {
    if (isAuthenticated || getToken) {
      // getVersion();
      if (getUserType === "Customer") history.push(RoutesConstants.LizeraStoreList);
      else history.push(RoutesConstants.CustomerLogin);
    }
  }, [isAuthenticated]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      if (error === errorMessage.UserAlreadyLogin) {
        props.confirmLoginPopupToggleHandler();
      } else {
        toast.error(formatMessage(error));
        authStore.reset();
      }
    }
  }, [error]);

  return (
    <>
      <div className="bg-img1 background">
        <CustomerLoginForm
          isLoading={inProgress}
          loginHandler={handleLogin}
          initialValues={initialValues}
        /> 
      </div>
      <Footer />
    </>
  );
};

export default observer(CustomerLogin);
